const elementRs = document.querySelector('input[name="isCountryRS"]');
const isCountryRS = elementRs ? elementRs.value == "1" : false;

const formFieldsBasic = [
    {
        field: "complaint_text",
        selector: 'textarea[name="customer_complaint_text"]',
    },
    {
        field: "complaint_registration",
        selector: 'input[name="customer_registration_text"]',
    },
]

if (isCountryRS) {
    formFieldsBasic.push(
        {
            field: "complaint_bank_name",
            selector: 'select[name="customer_bank_name"]',
        },
        {
            field: "accountZr2",
            selector: 'input[name="accountZr2"]',
        },
        {
            field: "accountZr3",
            selector: 'input[name="accountZr3"]',
        },
        {
            field: "accountZr",
            selector: 'select[name="accountZr"]',
        },
        {
            field: "complaint_account_number",
            selector: 'input[name="complaint_account_number"]',
        }
    );
}
const formFields = formFieldsBasic;

const objectionFormFields = [
    {
        field: "objection_item_number",
        selector: 'input[name="objection_item_number"]',
    },
    {field: "complaint_request_id", selector: "#complaint_request_id"},
    {
        field: "objection_item_date",
        selector: 'input[name="objection_item_date"]',
    },
    {
        field: "objection_item_options",
        selector: 'input[name="objection_item_options"]',
        type: "checkbox",
    },
    {
        field: "objection_item_reason",
        selector: 'textarea[name="objection_item_reason"]',
    },
];

export {formFields, objectionFormFields};
